// This is the base URL path for all design auto assignment routes
export const DesignAutoAssignmentBasePath = '/config/design-assignment';
